import { downloadAs } from '@utils/utils';
import { useQuery } from 'react-query';
import {
  downloadSecondaryMarketTransactionsExcelTemplate, getSecondaryMarketTransactionsListFilterOptions, postGetSecondaryMarketAllocationsList, postGetSecondaryMarketAllocationsTree, postGetSecondaryMarketChildAllocationsList, postGetSecondaryMarketTransactionsList,
} from './secondaryMarketApis';

export const useSecondaryMarketTransactionsList = (filterData: SecondaryMarket.GetSecondaryMarketTransactionsListParams) => useQuery(
  [
    'getSecondaryMarketTransactionsList',
    filterData.currentPage,
    filterData.pageSize,
    filterData.invoiceTermLoanFilter,
    filterData.statusFilter,
  ],
  async () => (await postGetSecondaryMarketTransactionsList(filterData)).data.data,
  {
    staleTime: 30 * 1000,
    cacheTime: 5 * 60 * 1000,
  },
);

export const useSecondaryMarketTransactionsListFilterOptions = () => useQuery(
  ['getSecondaryMarketTransactionsListFilterOptions'],
  getSecondaryMarketTransactionsListFilterOptions,
  {
    select: (d) => d.data.data,
  },
);

export const useSecondaryMarketTransactionsExcelTemplateDownload = () => useQuery(
  ['downloadSecondaryMarketTransactionsExcelTemplate'],
  downloadSecondaryMarketTransactionsExcelTemplate,
  {
    enabled: false,
    onSuccess: (resp) => {
      downloadAs(
        resp.data,
        'secondary_market_transactions_template.xlsx',
        'application/vnd.ms-excel',
      );
    },
  },
);

export const useSecondaryMarketAllocationsList = (filterData: SecondaryMarket.GetSecondaryMarketAllocationsListParams) => useQuery(
  [
    'getSecondaryMarketAllocationsList',
    filterData.currentPage,
    filterData.pageSize,
    filterData.investmentAllocationId,
  ],
  async () => (await postGetSecondaryMarketAllocationsList(filterData)).data.data,
  {
    staleTime: Infinity,
    cacheTime: Infinity,
  },
);

export const useSecondaryMarketAllocationsTree = (filterData: SecondaryMarket.GetSecondaryMarketAllocationsListParams) => useQuery(
  [
    'getSecondaryMarketAllocationsTree',
    filterData.investmentAllocationId,
  ],
  async () => (await postGetSecondaryMarketAllocationsTree(filterData)).data.data,
  {
    staleTime: Infinity,
    cacheTime: Infinity,
  },
);

export const useSecondaryMarketChildAllocationsList = (investmentAllocationId: number) => useQuery(
  [
    'getSecondaryMarketChildAllocationsList',
    investmentAllocationId,
  ],
  async () => (await postGetSecondaryMarketChildAllocationsList(investmentAllocationId)).data.data,
  {
    staleTime: Infinity,
    cacheTime: Infinity,
  },
);
